import sendForExecution from './store/send-for-execution';
import addResolutionWithExecution from './store/add-resolution-with-execution';

const dialogs = {
    namespaced: true,
    modules: {
        sendForExecution,
        addResolutionWithExecution
    }
}

export default dialogs;